module.exports = __webpack_public_path__ + "static/media/iStock-1284009639.90eb6338.jpg";